module.exports = __WEBPACK_EXTERNAL_MODULE__babylonjs_core_Shaders_ShadersInclude_instancesDeclaration__;